import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import type { WorkspaceTogglesStore } from "../types"

export const useWorkspaceTogglesStore = create<WorkspaceTogglesStore>()(
    immer((set, get) => ({
        // State
        workspaceToggles: null,
        loading: false,
        error: null,

        // Actions
        setWorkspaceToggles: (toggles: WorkspaceToggles) => {
            set((state) => {
                state.workspaceToggles = toggles
                state.loading = false
                state.error = null
            })
        },

        setLoading: (loading: boolean) => {
            set((state) => {
                state.loading = loading
            })
        },

        setError: (error: string | null) => {
            set((state) => {
                state.error = error
                state.loading = false
            })
        },

        clearWorkspaceToggles: () => {
            set((state) => {
                state.workspaceToggles = null
                state.loading = false
                state.error = null
            })
        },
    }))
)
